import React, { useCallback } from 'react';
import { Banner as BannerComponent } from 'decentraland-ui2';
import { getAnalytics } from '../../modules/analytics/utils';
import { sleep } from '../../lib/time';
export const Banner = (props) => {
    const { fields, id, ...rest } = props;
    const handleClick = useCallback((event) => {
        const anchorEvent = event;
        anchorEvent.preventDefault();
        const analytics = getAnalytics();
        if (analytics) {
            analytics.track('CLICK_BANNER', {
                id: fields?.id,
                location: id
            });
        }
        // Delay the navigation to allow the analytics to be tracked
        sleep(300).then(() => {
            window.location.href = anchorEvent.target.href;
        });
    }, [fields?.id, id]);
    return React.createElement(BannerComponent, { onClick: handleClick, fields: fields, ...rest });
};
//# sourceMappingURL=Banner.js.map